module.exports = __webpack_public_path__ + "img/img3.65f8d009.svg";